import React from 'react'
import { } from 'react-redux'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import { theme } from './theme'
import { ProductBuilderRoot } from '../features/product-builder/views'

export const App = () => <MuiThemeProvider theme={theme}>
    <ProductBuilderRoot />
</MuiThemeProvider>